import Vue from 'vue';
import Vuex from 'vuex';
import Language from '../enums/Language';

Vue.use(Vuex)

let savedLanguage = localStorage.getItem('language');
savedLanguage = savedLanguage ? JSON.parse(savedLanguage) : undefined;

const DEFAULT_DISMISS_TIME_ALERT = 5;

export default new Vuex.Store({
  state: {
    language: savedLanguage || Language.PORTUGUESE,
    alert: {
      show: false,
      message: '',
      style: '',
      code: 0
    },
    show: {
      title: false,
      loading: false
    },
    ref: {
      loading: {
        count: 0
      }
    },
  },
  getters: {
    loadingValue: state => state.show.loading,
    showAlert: state => state.alert.show,
    alertMessage: state => state.alert.message,
    alertStyle: state => state.alert.style,
  },
  mutations: {
    language: (state, language) => state.language = language,
    showLoading: (state, show) => {
      if (show) {
        state.ref.loading.count++;
        state.show.loading = true;
      } else if (state.ref.loading.count > 0) {
        state.ref.loading.count--;
        state.show.loading = (state.ref.loading.count > 0);
      }
    },
    showAlert: (state, { message, code, style, show }) => {
      if (show === undefined) show = DEFAULT_DISMISS_TIME_ALERT;
      state.alert = { message, code, style, show };
    },
  },
  actions: {
    language({commit}, language){
      if (language) localStorage.setItem('language', JSON.stringify(language));
      else localStorage.removeItem('language');
      commit('language', language);
    },
    showLoading: (context, show) => {
      context.commit("showLoading", show)
    },
    showAlert: (context, { message, code, style, show }) => {
      context.commit("showAlert", { message, code, style, show });
    },
    hideAlert: (context) => {
      context.commit("showAlert", { message: '', code: 0, style: '', show: false });
    },
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js